export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن حفظ رقم الهاتف المحمول. تحقق من الدخول وحفظ مرة أخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ وإرسال"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-DZ": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-EG": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن حفظ رقم الهاتف المحمول. تحقق من الدخول وحفظ مرة أخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ وإرسال"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-LB": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        }
      },
      "ar-MA": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-SA": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر إرسال الرسالة. يرجى التحقق من دخولك."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن حفظ رقم الهاتف المحمول. تحقق من الدخول وحفظ مرة أخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعد الإرسال"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ وإرسال"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-SY": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثوان"])}
        }
      },
      "ar-TN": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["تم إرسال رمز التوثيق عبر الرسائل القصيرة إلى ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل المصادقة عبر الرسائل النصية عن طريق إدخال رقم الجوال الصحيح. يتم تأكيد رقم الجوال عن طريق إدخال الرمز التوثيقي المستلم."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل مرة أخرى"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول بالتنسيق الدولي"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم الهاتف المحمول"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز التحقق من الرسائل القصيرة"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة الإرسال في ", _interpolate(_named("secondsPlaceholder")), " ثواني"])}
        }
      },
      "bg-BG": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Кодът за удостоверяване беше изпратен чрез СМС до ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съобщението не можа да бъде изпратено. Моля, проверете вашето въвеждане."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобилният номер не можа да бъде запазен. Проверете въведеното и запазете отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активация на удостоверяването по SMS чрез въвеждане на валиден мобилен номер. Потвърждението на мобилния номер се извършва чрез въвеждане на получения код за удостоверяване."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпрати отново"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобилен номер в международен формат"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете мобилен номер"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съхраняване и изпращане"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване от СМС"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Преизпрати след ", _interpolate(_named("secondsPlaceholder")), " секунди"])}
        }
      },
      "bs-BA": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijski kod je poslan putem SMS-a na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poruka se nije mogla poslati. Molimo provjerite svoj unos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobilnog telefona nije mogao biti sačuvan. Provjerite unos i ponovo sačuvajte."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija SMS autentifikacije unošenjem važećeg broja mobitela. Potvrda broja mobitela vrši se unošenjem primljenog autentifikacijskog koda."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji ponovo"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilni broj u međunarodnom formatu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite mobilni broj"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremite i pošaljite"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz SMS-a"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        }
      },
      "cs-CZ": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ověřovací kód byl odeslán pomocí SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zprávu se nepodařilo odeslat. Zkontrolujte prosím svůj údaj."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilní číslo se nepodařilo uložit. Zkontrolujte zadání a uložte znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivace ověřování pomocí SMS zadáním platného mobilního čísla. Potvrzení mobilního čísla se provede zadáním přijatého ověřovacího kódu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslat znovu"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilní číslo v mezinárodním formátu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte mobilní číslo"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit a odeslat"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód z SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu odeslat za ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        }
      },
      "da-DK": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Godkendelseskoden blev sendt via SMS til ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meddelelsen kunne ikke sendes. Tjek venligst din post."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummeret kunne ikke gemmes. Tjek indtastningen og gem igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering af SMS-godkendelse ved at indtaste et gyldigt mobilnummer. Bekræftelse af mobilnummeret sker ved at indtaste den modtagne godkendelseskode."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igen"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer i internationalt format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast mobilnummer"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gem og send"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificeringskode fra SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gensend om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "de-DE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Mobilnummer konnte nicht gespeichert. Eingabe überprüfen und erneut speichern."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung der Authentifizierung per SMS durch Eingabe einer gültigen Mobilnummer. Die Bestätigung der Mobilnummer erfolgt durch Eingabe des empfangenen Authentifizierungscodes."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer im internationalen Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer eingeben"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-AT": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Mobilnummer konnte nicht gespeichert. Eingabe überprüfen und erneut speichern."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung der Authentifizierung per SMS durch Eingabe einer gültigen Mobilnummer. Die Bestätigung der Mobilnummer erfolgt durch Eingabe des empfangenen Authentifizierungscodes."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer im internationalen Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handynummer eingeben"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an ", _interpolate(_named("mobileNumberPlaceholder")), " gesendet."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Mobilnummer konnte nicht gespeichert. Eingabe überprüfen und erneut speichern."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung der Authentifizierung per SMS durch Eingabe einer gültigen Mobilnummer. Die Bestätigung der Mobilnummer erfolgt durch Eingabe des empfangenen Authentifizierungscodes."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer im internationalen Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handynummer eingeben"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "de-LU": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde per SMS an mobileNumberPlaceholder gesendet."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivierung der Authentifizierung per SMS durch Eingabe einer gültigen Mobilnummer. Die Bestätigung der Mobilnummer erfolgt durch Eingabe des empfangenen Authentifizierungscodes."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer im internationalen Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handynummer eingeben"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode aus der SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("secondsPlaceholder")), " Sekunden"])}
        }
      },
      "el-GR": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επιβεβαίωσης στάλθηκε μέσω SMS στον ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποστολή του μηνύματος. Ελέγξτε την καταχώρισή σας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποθήκευση του αριθμού κινητού τηλεφώνου. Ελέγξτε την καταχώριση και αποθηκεύστε ξανά."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση της επιβεβαίωσης μέσω SMS με την εισαγωγή ενός έγκυρου κινητού τηλεφώνου. Η επιβεβαίωση του κινητού τηλεφώνου γίνεται με την εισαγωγή του κωδικού επιβεβαίωσης που έχει ληφθεί."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού στη διεθνή μορφή"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον αριθμό κινητού"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κώδικας επαλήθευσης από SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        }
      },
      "el-CY": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός επιβεβαίωσης στάλθηκε μέσω SMS στον ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποστολή του μηνύματος. Ελέγξτε την καταχώρισή σας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η αποθήκευση του αριθμού κινητού τηλεφώνου. Ελέγξτε την καταχώριση και αποθηκεύστε ξανά."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση της επιβεβαίωσης μέσω SMS με την εισαγωγή ενός έγκυρου κινητού τηλεφώνου. Η επιβεβαίωση του κινητού τηλεφώνου γίνεται με την εισαγωγή του κωδικού επιβεβαίωσης που έχει ληφθεί."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού στη διεθνή μορφή"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε τον αριθμό κινητού"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κώδικας επαλήθευσης από SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("secondsPlaceholder")), " δευτερόλεπτα"])}
        }
      },
      "en-GB": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The message could not be sent. Please check your entry."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The mobile number could not be saved. Check entry and save again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation of SMS authentication by entering a valid mobile number. The mobile number is confirmed by entering the received authentication code."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number in International Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter mobile number"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "en-IE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation of SMS authentication by entering a valid mobile number. The mobile number is confirmed by entering the received authentication code."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number in International Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter mobile number"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "en-US": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful Action"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The authentication code was sent via SMS to ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The message could not be sent. Please check your entry."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The mobile number could not be saved. Check entry and save again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation of SMS authentication by entering a valid mobile number. The mobile number is confirmed by entering the received authentication code."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number in International Format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter mobile number"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication Code from SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Resend in ", _interpolate(_named("secondsPlaceholder")), " Seconds"])}
        }
      },
      "es-ES": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["El código de autenticación se envió por SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El mensaje no se pudo enviar. Por favor revise su entrada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo guardar el número de móvil. Verifique la entrada y guarde nuevamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activación de la autenticación por SMS mediante la introducción de un número de teléfono móvil válido. La confirmación del número de móvil se realiza introduciendo el código de autenticación recibido."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar de nuevo"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de móvil en formato internacional"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el número de móvil"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar y enviar"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación del SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Volver a enviar en ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        }
      },
      "et-EE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentimiskood saadeti SMS-i teel ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sõnumit ei õnnestunud saata. Palun kontrollige oma sisestust."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiilinumbrit ei saanud salvestada. Kontrollige sisestust ja salvestage uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sõnumituvastuse aktiveerimine, sisestades kehtiva mobiilinumbri. Mobiilinumbri kinnitamine toimub sisestatud autentimiskoodi kaudu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada uuesti"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiilinumber rahvusvahelises formaadis"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage mobiilinumber"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvesta ja saada"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood SMSist"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("secondsPlaceholder")), " sekundi pärast"])}
        }
      },
      "fi-FI": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Vahvistuskoodi lähetettiin tekstiviestillä osoitteeseen ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viestiä ei voitu lähettää. Tarkista syöttösi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Matkapuhelinnumeroa ei voitu tallentaa. Tarkista syöte ja tallenna uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS-tunnistuksen aktivointi syöttämällä kelvollinen matkapuhelinnumero. Matkapuhelinnumero vahvistetaan syöttämällä saatu tunnistuskoodi."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekstiviesti"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä uudestaan"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Matkapuhelinnumero kansainvälisessä muodossa"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syötä matkapuhelinnumero"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tallenna ja lähetä"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentikointikoodi tekstiviestistä"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("secondsPlaceholder")), " sekunnin kuluttua"])}
        }
      },
      "fr-BE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le numéro de portable n'a pas pu être enregistré. Vérifiez l'entrée et enregistrez à nouveau."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation de l'authentification par SMS en entrant un numéro de mobile valide. La confirmation du numéro de mobile est faite en entrant le code d'authentification reçu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de mobile au format international"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le numéro de portable"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification du SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation de l'authentification par SMS en entrant un numéro de mobile valide. La confirmation du numéro de mobile est faite en entrant le code d'authentification reçu."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de mobile au format international"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le numéro de portable"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification du SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-FR": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le numéro de portable n'a pas pu être enregistré. Vérifiez l'entrée et enregistrez à nouveau."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation de l'authentification par SMS en entrant un numéro de mobile valide. La confirmation du numéro de mobile se fait par la saisie du code d'authentification reçu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de portable au format international"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le numéro de portable"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification du SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "fr-LU": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code d'authentification a été envoyé par SMS à ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le message n'a pas pu être envoyé. Veuillez vérifier votre saisie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le numéro de portable n'a pas pu être enregistré. Vérifiez l'entrée et enregistrez à nouveau."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation de l'authentification par SMS en entrant un numéro de portable valide. La confirmation du numéro de portable se fait par l'entrée du code d'authentification reçu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renvoyer"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de mobile au format international"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez le numéro de portable"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification du SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("secondsPlaceholder")), " secondes"])}
        }
      },
      "ga-IE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Seoladh cód deimhnithe via SMS go ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ní fhéadfaí an teachtaireacht a sheoladh. Seiceáil d’iontráil le do thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an uimhir soghluaiste a shábháil. Seiceáil iontráil agus sábháil arís."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtú fíordheimhniú SMS trí uimhir gutháin póca bailí a iontráil. Deimhnítear an uimhir gutháin póca trí an cód fíordheimhniúcháin a fuarthas a iontráil."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol arís"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir gutháin póca sa bhformat idirnáisiúnta"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach uimhir gutháin phóca"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábháil agus seol"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód deimhnithe ón SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athseoladh i ", _interpolate(_named("secondsPlaceholder")), " soicind"])}
        }
      },
      "he-IL": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["קוד האימות נשלח באמצעות הודעת טקסט אל ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לשלוח את ההודעה. אנא בדוק את הערך שלך."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לשמור את מספר הנייד. בדוק את הערך ושמור שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הפעלת אימות SMS על ידי הזנת מספר נייד חוקי. אישור מספר הטלפון הנייד מתבצע על ידי הזנת קוד האימות שהתקבל."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סמס"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח שוב"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר נייד בפורמט בינלאומי"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הכנס מספר נייד"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שמור ושלח"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות מה-SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בעוד ", _interpolate(_named("secondsPlaceholder")), " שניות"])}
        }
      },
      "hi-IN": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफल कार्रवाई"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["प्रमाणीकरण कोड को ", _interpolate(_named("mobileNumberPlaceholder")), " को एसएमएस के माध्यम से भेजा गया था।"])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["एक मान्य मोबाइल नंबर दर्ज करके एसएमएस प्रमाणीकरण का सक्रियन. मोबाइल नंबर की पुष्टि प्राप्त प्रमाणीकरण कोड दर्ज करके की जाती है."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फिर से भेजें"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अंतरराष्ट्रीय प्रारूप में मोबाइल नंबर"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मोबाइल नंबर दर्ज करें"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि करें"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["एसएमएस से प्रमाणीकरण कोड"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " सेकंड में पुन: भेजें"])}
        }
      },
      "hr-HR": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikacijski kod je poslan putem SMS-a na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poruka se nije mogla poslati. Molimo provjerite svoj unos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela nije bilo moguće spremiti. Provjerite unos i ponovno spremite."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija SMS autentifikacije unosom važećeg broja mobilnog telefona. Potvrda mobilnog broja se obavlja unosom primljenog autentifikacijskog koda."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji opet"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobilnog telefona u međunarodnom formatu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite broj mobitela"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremi i pošalji"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod iz SMS-a"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošalji za ", _interpolate(_named("secondsPlaceholder")), " sekundi"])}
        }
      },
      "hu-HU": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Az hitelesítő kód SMS-ben lett elküldve a ", _interpolate(_named("mobileNumberPlaceholder")), " számra."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az üzenetet nem sikerült elküldeni. Kérjük, ellenőrizze a bejegyzést."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A mobilszámot nem sikerült elmenteni. Ellenőrizze a bejegyzést, és mentse újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS hitelesítés aktiválása érvényes mobil szám megadásával. A mobil szám megerősítése a kapott hitelesítő kód megadásával történik."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Küldd újra"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiltelefon-szám nemzetközi formátumban"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg a mobil számát"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentés és küldés"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód SMS-ből"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("secondsPlaceholder")), " másodperc múlva"])}
        }
      },
      "it-CH": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione di successo"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione dell'autenticazione SMS inserendo un numero di cellulare valido. La conferma del numero di cellulare avviene inserendo il codice di autenticazione ricevuto."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero di cellulare in formato internazionale"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci il numero di cellulare"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dell'SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        }
      },
      "it-IT": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice di autenticazione è stato inviato tramite SMS a ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossibile inviare il messaggio. Si prega di controllare la tua voce."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile salvare il numero di cellulare. Controlla la voce e salva di nuovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione dell'autenticazione SMS inserendo un numero di cellulare valido. La conferma del numero di cellulare avviene inserendo il codice di autenticazione ricevuto."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero di cellulare in formato internazionale"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci il numero di cellulare"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva e invia"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione dell'SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia di nuovo fra ", _interpolate(_named("secondsPlaceholder")), " secondi"])}
        }
      },
      "ja-JP": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["認証コードは、SMSで", _interpolate(_named("mobileNumberPlaceholder")), "に送信されました。"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メッセージを送信できませんでした。 入力内容をご確認ください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号を保存できませんでした。 入力内容を確認し、再度保存してください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有効な携帯電話番号を入力して、SMS認証を有効にします。携帯電話番号の確認は、受け取った認証コードを入力することによって行われます。"])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もう一度送信"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["国際形式の携帯電話番号"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号を入力してください"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存して送信"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMSからの認証コード"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒後に再送信"])}
        }
      },
      "ko-KR": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["성공적인 액션"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["인증 코드가 ", _interpolate(_named("mobileNumberPlaceholder")), "에게 SMS로 전송되었습니다."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["유효한 휴대전화 번호를 입력하여 SMS 인증을 활성화합니다. 휴대전화 번호는 받은 인증 코드를 입력하여 확인됩니다."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["다시 보내기"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["국제 형식의 휴대전화 번호"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["휴대폰 번호를 입력하세요"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["확인"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS에서 인증 코드"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), "초 후에 재전송"])}
        }
      },
      "lt-LT": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikavimo kodas buvo išsiųstas SMS žinute į ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko išsiųsti pranešimo. Patikrinkite savo įrašą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko išsaugoti mobiliojo telefono numerio. Patikrinkite įrašą ir išsaugokite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS autentifikacijos aktyvavimas įvedant galiojantį mobiliojo telefono numerį. Mobilaus telefono numerio patvirtinimas atliekamas įvedant gautą autentifikacijos kodą."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trumpoji žinutė"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti dar kartą"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiliojo telefono numeris tarptautiniu formatu"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite mobiliojo telefono numerį"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išsaugoti ir siųsti"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas iš SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Persiųsti po ", _interpolate(_named("secondsPlaceholder")), " sekundžių"])}
        }
      },
      "lv-LV": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikācijas kods tika nosūtīts caur SMS uz ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ziņojumu nevarēja nosūtīt. Lūdzu, pārbaudiet savu ierakstu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilā tālruņa numuru nevarēja saglabāt. Pārbaudiet ierakstu un saglabājiet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS autentifikācijas aktivizēšana, ievadot derīgu mobilā tālruņa numuru. Mobilā tālruņa numura apstiprināšana notiek, ievadot saņemto autentifikācijas kodu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Īsziņa"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt vēlreiz"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilā telefona numurs starptautiskā formātā"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet mobilā telefona numuru"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saglabāt un nosūtīt"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods no SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("secondsPlaceholder")), " sekundēm"])}
        }
      },
      "mt-MT": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ġie mibgħut permezz ta' SMS lil ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-messaġġ ma setax jintbagħat. Jekk jogħġbok iċċekkja d-dħul tiegħek."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-numru tal-mowbajl ma setax jiġi salvat. Iċċekkja d-dħul u erġa ssejvja."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazzjoni tal-aġġornament tal-SMS billi tidħol numru ta' mobbli valida. Il-konferma tan-numru tal-mobbli ssir billi tidħol il-kodiċi ta' aġġornament riċevut."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat mill-ġdid"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numru tal-mowbajl fil-format internazzjonali"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Idħol numru tal-mowbajl"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat u ssejvja"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' awtentikazzjoni mis-SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ibgħat mill-ġdid fi ", _interpolate(_named("secondsPlaceholder")), " sekondi"])}
        }
      },
      "nb-NO": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentiseringskoden ble sendt via SMS til ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering av SMS-autentisering ved å legge inn et gyldig mobilnummer. Mobilnummeret blir bekreftet ved å legge inn den mottatte autentiseringskoden."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igjen"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer i internasjonalt format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn mobilnummer"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekrefte"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskode fra SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send på nytt om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "nl-BE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode werd via SMS naar ", _interpolate(_named("mobileNumberPlaceholder")), " gestuurd."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activatie van SMS-authenticatie door het invoeren van een geldig mobiel nummer. De bevestiging van het mobiele nummer gebeurt door het invoeren van de ontvangen authenticatiecode."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiel nummer in internationaal formaat"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer mobiel nummer in"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        }
      },
      "nl-NL": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De authenticatiecode werd via SMS naar ", _interpolate(_named("mobileNumberPlaceholder")), " gestuurd."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het bericht kon niet worden verzonden. Controleer uw invoer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Het mobiele nummer kon niet worden opgeslagen. Controleer invoer en sla opnieuw op."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activatie van SMS-authenticatie door het invoeren van een geldig mobiel nummer. De bevestiging van het mobiele nummer gebeurt door het invoeren van de ontvangen authenticatiecode."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiel nummer in internationaal formaat"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer mobiel nummer in"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opslaan en verzenden"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode uit de SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opnieuw verzenden over ", _interpolate(_named("secondsPlaceholder")), " seconden"])}
        }
      },
      "pl-PL": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod autoryzacyjny został wysłany za pośrednictwem SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się wysłać wiadomości. Sprawdź swój wpis."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie można zapisać numeru telefonu komórkowego. Sprawdź wpis i zapisz ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywacja uwierzytelniania SMS przez wprowadzenie poprawnego numeru telefonu komórkowego. Potwierdzenie numeru telefonu komórkowego następuje poprzez wprowadzenie otrzymanego kodu uwierzytelniającego."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij ponownie"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer telefonu komórkowego w formacie międzynarodowym"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź numer telefonu komórkowego"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz i wyślij"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod autoryzacyjny z SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        }
      },
      "pt-PT": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["O código de autenticação foi enviado por SMS para ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A mensagem não pôde ser enviada. Por favor, verifique sua entrada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O número do celular não pôde ser salvo. Verifique a entrada e salve novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativação da autenticação por SMS através da introdução de um número de telemóvel válido. A confirmação do número de telemóvel é feita através da introdução do código de autenticação recebido."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie novamente"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de telemóvel em formato internacional"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Insira o número do celular"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar e enviar"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação do SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("secondsPlaceholder")), " segundos"])}
        }
      },
      "ro-RO": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Codul de autentificare a fost trimis prin SMS la ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesajul nu a putut fi trimis. Vă rugăm să verificați intrarea."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numărul de mobil nu a putut fi salvat. Verificați intrarea și salvați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activarea autentificării prin SMS prin introducerea unui număr de mobil valid. Confirmarea numărului de mobil se realizează prin introducerea codului de autentificare primit."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimite din nou"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numar de telefon mobil în format internațional"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți numărul de mobil"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvare și trimitere"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare din SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimite în ", _interpolate(_named("secondsPlaceholder")), " secunde"])}
        }
      },
      "ru-RU": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код аутентификации был отправлен по SMS на ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сообщение не может быть отправлено. Пожалуйста, проверьте вашу запись."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не удалось сохранить номер мобильного телефона. Проверьте запись и сохраните снова."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активация аутентификации по SMS путем ввода действительного номера мобильного телефона. Подтверждение номера мобильного телефона происходит путем ввода полученного кода аутентификации."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправь еще раз"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер мобильного телефона в международном формате"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите номер мобильного телефона"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить и отправить"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации из SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить снова через ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        }
      },
      "sk-SK": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentifikačný kód bol odoslaný pomocou SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správu sa nepodarilo odoslať. Skontrolujte svoje zadanie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilné číslo sa nepodarilo uložiť. Skontrolujte zadanie a znova uložte."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivácia autentifikácie SMS zadaním platného mobilného čísla. Potvrdenie mobilného čísla sa vykonáva zadaním prijatého autentifikačného kódu."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslať znova"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilné číslo v medzinárodnom formáte"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte mobilné číslo"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložiť a odoslať"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód z SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Znovu poslať o ", _interpolate(_named("secondsPlaceholder")), " sekundy"])}
        }
      },
      "sl-SI": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Avtentikacijska koda je bila poslana preko SMS na ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sporočila ni bilo mogoče poslati. Prosimo, preverite svoj vnos."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Številke mobilnega telefona ni bilo mogoče shraniti. Preverite vnos in znova shranite."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivacija SMS avtentikacije z vnosom veljavne mobilne številke. Potrditev mobilne številke se izvede z vnosom prejetega avtentikacijskega kode."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji ponovno"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilna številka v mednarodni obliki"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite mobilno številko"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shrani in pošlji"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avtentikacijska koda iz SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji čez ", _interpolate(_named("secondsPlaceholder")), " sekund"])}
        }
      },
      "sv-SE": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Autentiseringskoden skickades via SMS till ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meddelandet kunde inte skickas. Kontrollera ditt bidrag."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnumret kunde inte sparas. Kontrollera inmatningen och spara igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivering av SMS-autentisering genom att ange ett giltigt mobilnummer. Mobilnumret bekräftas genom att ange den mottagna autentiseringskoden."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka igen"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer i internationellt format"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange mobilnummer"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spara och skicka"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod från SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("secondsPlaceholder")), " sekunder"])}
        }
      },
      "th-TH": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การดำเนินการที่ประสบความสำเร็จ"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["รหัสการตรวจสอบถูกส่งผ่าน SMS ไปยัง ", _interpolate(_named("mobileNumberPlaceholder"))])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["การเปิดใช้งานการตรวจสอบความถูกต้องทาง SMS โดยการป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง การยืนยันหมายเลขโทรศัพท์มือถือทำได้โดยการป้อนรหัสการตรวจสอบความถูกต้องที่ได้รับ"])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ส่งอีกครั้ง"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["หมายเลขโทรศัพท์มือถือในรูปแบบสากล"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนหมายเลขโทรศัพท์มือถือ"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ยืนยัน"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["รหัสการยืนยันจาก SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["ส่งใหม่ใน ", _interpolate(_named("secondsPlaceholder")), " วินาที"])}
        }
      },
      "tr-CY": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodu, SMS ile ", _interpolate(_named("mobileNumberPlaceholder")), "'a gönderildi."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesaj gönderilemedi. Lütfen girişinizi kontrol edin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numarası kaydedilemedi. Girişi kontrol edin ve tekrar kaydedin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geçerli bir cep telefonu numarası girerek SMS doğrulamasının etkinleştirilmesi. Cep telefonu numarasının onayı, alınan doğrulama kodunun girilmesiyle gerçekleştirilir."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uluslararası formatda mobil numara"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numarasını girin"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve gönder"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS'den doğrulama kodu"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        }
      },
      "tr-TR": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodu, SMS ile ", _interpolate(_named("mobileNumberPlaceholder")), "'a gönderildi."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mesaj gönderilemedi. Lütfen girişinizi kontrol edin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numarası kaydedilemedi. Girişi kontrol edin ve tekrar kaydedin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geçerli bir cep telefonu numarası girerek SMS doğrulamasının etkinleştirilmesi. Cep telefonu numarasının onayı, alınan doğrulama kodunun girilmesiyle gerçekleştirilir."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uluslararası formatda mobil numara"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numarasını girin"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve gönder"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS'den doğrulama kodu"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " saniye sonra yeniden gönder"])}
        }
      },
      "uk-UA": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішна дія"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код автентифікації був відправлений через SMS на ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Nachricht konnte nicht gesendet werden. Bitte prüfe deine Eingabe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не вдалося зберегти номер мобільного телефону. Перевірте введення та збережіть ще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активація аутентифікації за допомогою SMS шляхом введення дійсного мобільного номера. Підтвердження мобільного номера відбувається за допомогою введення отриманого коду аутентифікації."])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Надіслати знову"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер мобільного телефону в міжнародному форматі"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть номер мобільного"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти та відправити"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації з SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Надіслати знову за ", _interpolate(_named("secondsPlaceholder")), " секунд"])}
        }
      },
      "vi-VN": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hành động thành công"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Mã xác thực đã được gửi qua SMS đến ", _interpolate(_named("mobileNumberPlaceholder")), "."])}
            },
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kích hoạt xác thực SMS bằng cách nhập một số di động hợp lệ. Xác nhận số di động được thực hiện bằng cách nhập mã xác thực đã nhận."])}
        },
        "SMSSetupForm": {
          
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gửi lại"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Số điện thoại di động theo định dạng quốc tế"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập số điện thoại di động"])}
          }
        },
        "saveMobileNumber": {
          
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Xác nhận"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mã xác thực từ SMS"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gửi lại sau ", _interpolate(_named("secondsPlaceholder")), " giây"])}
        }
      },
      "zh-CN": {
        "notification": {
          "sendSMS": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["身份验证代码已通过短信发送至", _interpolate(_named("mobileNumberPlaceholder")), "。"])}
            },
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法发送消息。 请检查您的输入。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          },
          "saveMobileNumber": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法保存手机号码。 检查条目并再次保存。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过输入有效的手机号码激活短信认证。通过输入接收到的认证代码来确认手机号码。"])}
        },
        "SMSSetupForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])}
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新发送"])}
        },
        "mobileNumber": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["国际格式的手机号码"])},
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入手机号码"])}
          }
        },
        "saveMobileNumber": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存并发送"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "SMSOTP": {
          "input": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["来自短信的认证码"])}
          }
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("secondsPlaceholder")), " 秒后重新发送"])}
        }
      }
    }
  })
}
